import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminGroup, AdminGroups, AdminGroupsState } from 'Interfaces/Admin';

const INITIAL_STATE: AdminGroupsState = {
  loaded: false,
  collection: [],
};

const adminGroupsSlice = createSlice({
  name: 'adminGroups',
  initialState: INITIAL_STATE,
  reducers: {
    loadedAdminGroups(state, action: PayloadAction<AdminGroups>) {
      return { loaded: true, collection: action.payload };
    },
    /** Adds the group, or merges it over the existing one with the same id. */
    upsertAdminGroup(state, action: PayloadAction<AdminGroup>) {
      const group = action.payload;
      const index = state.collection.findIndex((g) => g.id === group.id);
      if (index === -1) {
        state.collection.push(group);
      } else {
        state.collection[index] = { ...state.collection[index], ...group };
      }
    },
    /**
     *  Groups are never removed outright — deletion deactivates them, which is
     *  what the delete endpoint reports back.
     */
    deactivateAdminGroups(state, action: PayloadAction<number[]>) {
      const ids = action.payload;
      state.collection = state.collection.map((g) =>
        ids.includes(g.id) ? { ...g, active: false } : g,
      );
    },
  },
});

export const {
  loadedAdminGroups, upsertAdminGroup, deactivateAdminGroups,
} = adminGroupsSlice.actions;

export default adminGroupsSlice.reducer;
